export const conditionalLink = (condition, link) => {
  return condition ? link : link.props.children
}

export const ConditionalWrapper = ({ wrap = false, children }) =>
  wrap ? children : children.props.children



// WEBPACK FOOTER //
// ./src/conditional-link/index.js